<!--
	TEMPLATE
-->
<template>
<div class="editable-text editable-address">
	<div v-if="!isEditView">
			{{ address.flatNumber ? address.flatNumber + ', ' : '' }}{{ address.buildingNumber ? address.buildingNumber : '' }} {{ address.street }}<br>
			{{ address.town !== '' ? address.town + ', ' : '' }}{{ address.county }}<br>
			{{ address.postcode }}
	</div>

	<div v-if="isEditView">
		<!-- manually -->
		<address-input v-if="addressManually" v-model="address" :attentionSymbol="options.attentionSymbol" @change="addressChanged"></address-input>

		<!-- google places -->
		<google-places-input v-if="!showAddressSummary && !addressManually" v-on:googlePlacesUpdated="googlePlacesUpdated" placeholder="Type '28 Street name' or Full postcode"></google-places-input>

		<!-- Address summary -->
		<div v-if="showAddressSummary && !addressManually">
			<!-- Flat number -->
			<div class="form-group editable-address__flat-number">
				<input type="text" v-model="address.flatNumber" name="flatNumber" placeholder="Enter number/letter if Flat">
			</div>
			<!-- Street number -->
			<div class="form-group" v-if="showStreetNumberInput">
				 <input type="text" v-model="address.buildingNumber" placeholder="Enter street/building number">
			</div>

			<div class="form-group">
				<div class="text-center editable-address__google-places-address">
					<span class="address-number" v-if="address.flatNumber != ''">{{ address.flatNumber }}, </span>
					<span>{{ shortAddress }}</span>
					<span>{{ address.town }}</span>
					<span>{{ address.postcode }}</span>
				</div>
			</div>
		</div>

		<!-- toggle -->
		<div class="btn--change"><a href="#" @click.prevent="addressManually = !addressManually">{{ editLabel }}</a></div>
	</div>
</div>
</template>

<!--
	SCRIPT
-->
<script>
import vModelNested from '@/libs/vModelNested.js';
import AddressInput from '../AddressInput.vue';
import GooglePlacesInput from '../GooglePlacesInput.vue';

export default {
	props: {
		value: Object,
		options: {
			type: Object,
			default: {
				attentionSymbol: true,
				startOnManual: true
			}
		},
		isEditView: Boolean
	},
	data: function() {
		return {
			addressManually: true,
			showAddressSummary: false,
			showStreetNumberInput: false
		}
	},
	components: {
		'address-input': AddressInput,
		'google-places-input': GooglePlacesInput
	},
	computed: {
		address: vModelNested,
		editLabel: function() {
			return this.addressManually ? 'Use Google Places' : 'Edit address manually'
		},
		shortAddress: function() {
			 var address = '';
			 if(this.address.buildingNumber != '') {
				  address += this.address.buildingNumber + ' ';
			 }
			 address += this.address.street;
			 return address;
		}
	},
	mounted: function() {
		this.addressManually = this.options.startOnManual === false ? false : true;
	},
	watch: {
		 address: {
			handler: function () {
				//console.log('address changed');
				 this.generateLatLng();
				 this.$emit('changed');
				 this.$emit('hasErrors', !this.address.addressNotEmpty);
			  },
			deep: true
		 }
	},
	methods: {
		googlePlacesUpdated: function(place) {
			if (place.street == '' || place.postcode == '') {
				 return;
			}

			this.address.buildingNumber = place.buildingNumber;
			this.address.street = place.street;
			this.address.postcode = place.postcode;
			this.address.town = place.town;
			this.address.county = place.county;
			this.address.latitude = place.lat;
			this.address.longitude = place.lng;

			this.$emit('changed');

			this.showStreetNumberInput = this.address.buildingNumber == '';

			if(this.options.goManualOnSuccess) {
				this.addressManually = true;
			} else {
				this.showAddressSummary = true;
			}
		},
		generateLatLng: function() {
			if (this.address.street !== '' && this.address.postcode !== '') {
				var geocoder = new google.maps.Geocoder();
				var self = this;
				geocoder.geocode({
				    	'address': this.address.street,
				    	'componentRestrictions': {
				        		'postalCode': this.address.postcode,
				        		'country': 'gb'
				    	}
				}, function (results, status) {
				    if (status === google.maps.GeocoderStatus.OK) {
				    	self.address.latitude = results[0].geometry.location.lat();
				    	self.address.longitude = results[0].geometry.location.lng();
					}
				})
			}
		},
		addressChanged: function() {
			this.$emit('changed');
		}
	}
}
</script>
